import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from '@shared/ui/button';
import { useMobileShell } from '@shared/shell';

export const MobileMenuButton: React.FC = () => {
  const { toggleLauncher } = useMobileShell();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleLauncher}
      className="h-9 w-9 min-h-[44px] min-w-[44px] text-navbar-muted hover:text-navbar-foreground hover:bg-navbar-accent md:hidden shrink-0 flex items-center justify-center cursor-pointer"
      aria-label="Toggle navigation menu"
    >
      <Menu className="h-5 w-5" />
    </Button>
  );
};
